// extracted by css-extract-rspack-plugin
export default {"list":"list-gbddB3","item":"item-eY1Z4d","head":"head-IaFEyq","name":"name-H76cNL","error":"error-WY2hta"};